import {
  api_stuTypingPlanetSelectById,
  api_stuTypingPlanetSaveOrUpdate
} from '@/api/javaApi'

const workdata = {
  state: {
    exampal_work_url: "", //课堂作品完整版
    home_template_url: "", //课程引导
    teach_template_url: "", //授课空模板
    course_work_url: "", //课堂作品
    home_work_url: "",   //课后作品
    teach_work_url: "", //老师课堂作品
    //打字星球进度
    typingPlanetProgress: {
      typingHistory: [],
      completedLevels: [],
      // puzzleConnectRecords_${id}:[],
      // puzzleRecords_${id}:[],
      // dragImageRecords_${id}:[],
      // highScore_${id}:'',
    },
  },
  mutations: {
    SET_COURSE_WORK_URL: (state, data) => {
      state.course_work_url = data;
      localStorage.setItem('course_work_url', data);
    },
    RESET_COURSE_WORK_URL: (state) => {
      state.course_work_url = "";
    },

    SET_TEACH_WORK_URL: (state, data) => {
      state.teach_work_url = data;
      localStorage.setItem('teach_work_url', data);
    },
    RESET_TEACH_WORK_URL: (state) => {
      state.teach_work_url = "";
    },


    SET_HOME_WORK_URL: (state, data) => {
      state.home_work_url = data;
      localStorage.setItem('home_work_url', data);
    },
    RESET_HOME_WORK_URL: (state) => {
      state.home_work_url = "";
    },

    SET_EXAM_WORK_URL: (state, data) => {
      state.exampal_work_url = data;
      localStorage.setItem('exampal_work_url', data);
    },
    RESET_EXAM_WORK_URL: (state) => {
      state.exampal_work_url = "";
    },

    SET_HOME_TEMPLATE_URL: (state, data) => {
      state.home_template_url = data;
      localStorage.setItem('home_template_url', data);
    },
    RESET_HOME_TEMPLATE_URL: (state) => {
      state.home_template_url = "";
    },

    SET_TEACH_TEMPLATE_URL: (state, data) => {
      state.teach_template_url = data;
      localStorage.setItem('teach_template_url', data);
    },
    RESET_TEACH_TEMPLATE_URL: (state) => {
      state.teach_template_url = "";
    },
    SET_TYPING_PLANET_PROGRESS: (state, data) => {
      if (data) {
        state.typingPlanetProgress = JSON.parse(data);
        Object.keys(state.typingPlanetProgress).forEach(key => {
          localStorage.setItem(key, JSON.stringify(state.typingPlanetProgress[key]));
        });
      }
    },
  },
  actions: {
    /**
     progress值是一个json字符串，可以自定义内容
     */
    // 查询学生的打字星球进度
    async stuTypingPlanetSelectById({ commit }) {
      return new Promise((resolve) => {
        api_stuTypingPlanetSelectById().then(res => {
          commit('SET_TYPING_PLANET_PROGRESS', res.progress)
          resolve('打字进度初始化完成')
        })
      })
    },
    // 保存或更新学生的打字星球进度
    stuTypingPlanetSaveOrUpdate({ dispatch, state }, { key, value }) {
      let progress = { ...state.typingPlanetProgress }

      // 支持批量保存
      if (key === 'batchSave' && typeof value === 'object') {
        // 批量更新多个键值对
        Object.keys(value).forEach(batchKey => {
          const batchValue = value[batchKey]
          const v = JSON.stringify(batchValue)
          if (v !== '""' && v !== '{}' && v !== '[]' && v !== 'null' && v !== 'undefined' && v !== '0') {
            progress[batchKey] = batchValue
          } else {
            delete progress[batchKey]
          }
        })
      } else {
        // 原有的单个键值对保存逻辑
        const v = JSON.stringify(value)
        if (v !== '""' && v !== '{}' && v !== '[]' && v !== 'null' && v !== 'undefined' && v !== '0') {
          progress[key] = value
        } else {
          delete progress[key]
        }
      }

      api_stuTypingPlanetSaveOrUpdate({ progress: JSON.stringify(progress) }).then(() => {
        dispatch('stuTypingPlanetSelectById')
      })
    },
    removeTypingPlanetProgress({ state }) {
      Object.keys(state.typingPlanetProgress).forEach(key => {
        console.log('要删除的key', key)
        localStorage.removeItem(key);
      });
    }
  }
};

export default workdata;